<!-- Questions -->
<div class="c-survey__section survey-question">
  @for (text of questionDetails.QuestionText; track text) {
    <h2 [attr.headerid]="text" class="c-survey__question">{{ text | translate }}</h2>
  }
</div>
<div class="c-survey__section survey-choices">
  <!-- Sleep face label -->
  <div id="sleepinessImage" class="c-sleep-icon is-selected-sleepiness">
    <img src="assets/images/{{sleepinessSelectedImageFile}}" />
  </div>

  <h3  class="c-sleepiness-choice" [attr.sleepinessid]="selectYourSleepinessStringId">
    @if (answerText) {
      <span>{{ answerText | translate }}</span>
    }
    @if (!answerText) {
      <span>{{ selectYourSleepinessStringId | translate }}</span>
    }
  </h3>
  <div hidden>
    <!-- preload all images to reduce UI lag -->
    @for (img of preloadHiddenImageSources; track img) {
      <div hidden>
        <img hidden src="assets/images/{{img}}" />
      </div>
    }
  </div>
  <!-- Sleep faces -->
  <div class="c-sleepiness-options">
    <div class="o-layout o-layout--small">
      @for (answer of questionDetails.PossibleAnswers; track answer; let i = $index) {
        <div class="o-layout__item u-1/5">
          <div class="c-sleep-icon" [class.is-selected]="i === selectedImageIndex">
            <img (click)="this.imageSelected(answer, i)" [attr.answerid]="answerIds[i]" src="assets/images/{{imageSources[i]}}" />
          </div>
        </div>
      }
    </div>
  </div>
</div>
